<template>
    <div class="data-list-container">
        <vs-row class="mb-4">
            <vs-col vs-w="3">
                <v-select class="" label="name" placeholder="Sélectionner une période" :reduce="period => period.id" v-model="period_id" :options="periods"></v-select>
            </vs-col>
            <vs-col vs-w="3">
                <v-select class="ml-4" label="name" placeholder="Sélectionner une évaluation" :reduce="evaluation => evaluation.id" v-model="quizz_id" :options="evals"></v-select>
            </vs-col>
        </vs-row>
        <vs-divider></vs-divider>
        <vs-table ref="table" max-items="10" search :data="datas">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <div
                            @click="loadDatas()"
                            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Actualiser</span>
                    </div>
                    <div
                            @click="exportData()"
                            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Exporter</span>
                    </div>
                    
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="evaluation_name">Evaluation</vs-th>
                <vs-th sort-key="questionnaire">Questionnaire</vs-th>
                <vs-th sort-key="question">Question</vs-th>
                <vs-th sort-key="type_question">Type</vs-th>
                <vs-th sort-key="difficulty">Difficulté</vs-th>
                <vs-th sort-key="question_marks">Nb de points</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.evaluation_name }}</vs-td>
                    <vs-td>{{tr.questionnaire }}</vs-td>
                    <vs-td>{{tr.question }}</vs-td>
                    <vs-td>{{typeQuestions(tr.type_question) }}</vs-td>
                    <vs-td>{{difficulties(tr.difficulty) }}</vs-td>
                    <vs-td>{{tr.question_marks }}</vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <!--<vs-row>
            <vs-col vs-offset="10" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
            </vs-col>
        </vs-row>-->
    </div>
</template>

<script>
    import {_buildQuery} from "../../../helpers/buildquery";

    export default {
        components: {},
        watch: {
            /*page(value) {
                this.loadDatas(value);
            },*/
        },
        data: () => ({
            datas: [],
            page: 1,
            last_page: null,
            periods: [],
            evals: [],
            period_id: "",
            quizz_id: ""
        }),
        watch: {
            period_id: function (val) {
                if (val) {
                    this.loadEvals();
                }else this.loadDatas();
            },
            quizz_id: function () {
                this.loadDatas();
            }
        },
        computed: {},
        methods: {
            loadDatas() {
                let params = {
                    nb: 10,
                    period_id: this.period_id ? this.period_id : "",
                    quizz_id: this.quizz_id ? this.quizz_id : ""
                }
                this.$vs.loading()
                this.$http.get('/stats/questions/miss' + _buildQuery(params)).then((response) => {
                    this.datas = response.data
                    this.$vs.loading.close()


                }).catch((error) => {
                    console.log(error)
                    this.$vs.loading.close()
                })


            },
            async exportData(){
                    this.$vs.loading()
                    let params = {
                        period_id: this.period_id,
                        quizz_id: this.quizz_id
                    }
                    const response = await this.$http({
                        url: 'stats/questions/miss/export' + _buildQuery(params),
                        method: 'GET',
                        responseType: 'blob',
                    })
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Top10missingQuestions.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.$vs.loading.close()
            },
            difficulties(niveau) {
                let level = "";
                switch (niveau) {
                    case 'medium':
                        level = 'Moyen';
                        break;
                    case 'esay':
                        level = 'Facile';
                        break;
                    case 'hard':
                        level = 'Difficile';
                        break;
                }
                return level;
            },
            typeQuestions(type_question) {
                let type = "";
                switch (type_question) {
                    case 'radio':
                        type = 'Une réponse unique';
                        break;
                    case 'checkbox':
                        type = 'Plusieurs réponse possible';
                        break;
                    case 'text':
                        type = 'Unique texte';
                }
                return type;
            },
            loadPeriods() {
                this.$http.get('/periods').then((response) => {
                    this.periods = response.data;
                }).catch((error) => {
                    console.log(error)
                    this.$vs.loading.close()
                })
            },
            loadEvals() {
                this.$http.get('/stats/questions/miss/get-evals?period_id='+this.period_id).then((response) => {
                    this.evals = response.data;
                }).catch((error) => {
                    console.log(error)
                    this.$vs.loading.close()
                })
            }

        },
        mounted() {
            this.loadDatas();
            this.loadPeriods();
            this.loadEvals();
        },
    };
</script>
